import { field } from "@/assets/js/consts";
import { MessageBox, Loading } from "element-ui";
import router from "@/router";
import { CodeToText, TextToCode } from "@/assets/js/app";

/**
 * 判断结果数据是否执行正常
 * @param {json} res
 */
export function isSuccess (res) {
  if (res.data == undefined) {
    res.data = [];
  }
  if (res.biz_code == 200) {
    if (res.data.code) {
      setTimeout(() => {
        toast("验证码：" + res.data.code);
      }, 1000);
    }
    return res.data;
  } else {
    // alert(res.biz_msg)
  }
}

/**
 * 路由跳转
 * @param {*} url
 */
export function toUrl (url, code) {
  if (code) {
    if (checkCode(code)) {
      router.push(url);
    }
  } else {
    router.push(url);
  }
}

/**
 * 替换模式路由跳转，不可返回上一级
 * @param {*} url
 */
export function replaceUrl (url) {
  router.replaceUrl(url);
}

/**
 * 检查用户是否具有指定的权限代码
 */
export function checkCode (code) {
  if (_global_.CODES) {
    return _global_.CODES.indexOf(code) == -1;
  }
  return false;
}

/**
 * 打开登录界面
 */
export function openLogin () {
  toUrl("/auth/login");
}

/**
 * 判断是否登录
 */
export function isLogin () {
  if (getToken()) {
    return true;
  }
  return false;
}

/**
 * 获取Token信息
 */
export function getToken () {
  return _global_.TOKEN;
}

/**
 * 退出登录
 */
export function loginOut () {
  window.localStorage.clear();
  toUrl("/");
}
//将地址汉字转换成code
export function toCodeOne (bA = [], bs, bc, ba) {
  console.log(bs, bc, ba)
  let codeArr = {};
  let bcCode = null;
  // bA.push(TextToCode[bs].code);
  if (bs == bc) {
    console.log(1)
    //直辖市
    bcCode = "市辖区";
    bA.push(TextToCode[bs].code);
    bA.push(TextToCode[bs][bcCode].code);
    bA.push(TextToCode[bs][bcCode][ba].code);

    codeArr.arrCode = bA;
    return codeArr;
  } else if (bc == ba) {
    let text = bc.substr(bc.length - 1, 1)
    //省级县
    if (text == '区') {
      bcCode = "市辖区";
      bA.push(TextToCode[bs].code);
      bA.push(TextToCode[bs][bcCode].code);
      bA.push(TextToCode[bs][bcCode][ba].code);
      codeArr.arrCode = bA;
      return codeArr;
    }
    if (text == '县') {
      bcCode = "县";
      bA.push(TextToCode[bs].code);
      bA.push(TextToCode[bs][bcCode].code);
      bA.push(TextToCode[bs][bcCode][ba].code);
      codeArr.arrCode = bA;
      return codeArr;
    }
    if (text == '市') {
      bA.push(TextToCode[bs].code);
      bA.push(TextToCode[bs][bc].code);
      codeArr.arrCode = bA;
      return codeArr;
    }
  } else {
    console.log(3)
    bA.push(TextToCode[bs].code);
    bA.push(TextToCode[bs][bc].code);
    if (ba) {
      bA.push(TextToCode[bs][bc][ba].code);
    }
    codeArr.arrCode = bA;
    console.log(codeArr)
    return codeArr;
  }
}

//将地址code转换为汉字
export function toTextOne (beginAddress = []) {
  let Address = [];
  Address[0] = CodeToText[beginAddress[0]];
  Address[1] = CodeToText[beginAddress[1]];
  if (beginAddress[2]) {
    Address[2] = CodeToText[beginAddress[2]];
  } else {
    Address[2] = CodeToText[beginAddress[1]];
  }

  return Address;
}
/**
 * 获取用户按钮权限
 */
export function refreshLoginInfo (vm, fun) {
  vm.api(170304, { style: "PC" }).then(res => {
    _global_.CODES = res.data.code;
  });
}

/**
 * 获取当前登录的用户信息
 * @param {*} fun
 */
export function getCurrentUserInfo () {
  if (_global_.TOKEN_LIST) {
    for (var i = 0; i < _global_.TOKEN_LIST.length; i++) {
      var userInfo = _global_.TOKEN_LIST[i];
      if (userInfo.type.name == _global_.USER_TYPE) {
        return userInfo;
      }
    }
  }
  return null;
}

/**
 * 数据模型
 */
export const model = {
  /**
   * 图片上传模型
   * @param {*} title 标题
   * @param {*} controlType 类型[date|more|text]
   * @param {*} imageType 图片类型 DrivingLicense
   * @param {*} required 是否必需上传
   * @param {*} disabled 禁用
   */

  //只传图片地址
  getModel: function (title, required, disabled) {
    return {
      _title: title,
      _required: required,
      _disabled: disabled,
      image_url: "",
      pid: ""
    };
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/utils.js